import type { Glyph } from "./types";

export const MenuIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M43 24.1C43.497 24.1 43.901 24.503 43.901 25C43.901 25.497 43.497 25.901 43 25.901L7 25.901C6.503 25.901 6.1 25.497 6.1 25C6.1 24.503 6.503 24.1 7 24.1L43 24.1ZM43 10.1C43.497 10.1 43.901 10.503 43.901 11C43.901 11.497 43.497 11.901 43 11.901L7 11.901C6.503 11.901 6.1 11.497 6.1 11C6.1 10.503 6.503 10.1 7 10.1L43 10.1Z" />
    <path d="M43 38.1C43.497 38.1 43.901 38.503 43.901 39C43.901 39.497 43.497 39.901 43 39.901L7 39.901C6.503 39.901 6.1 39.497 6.1 39C6.1 38.503 6.503 38.1 7 38.1L43 38.1Z" />
  </svg>
);

export default MenuIcon;
